<div class="login-screen">
    <div class="row m-0">
        <div class="col-lg-7 p-0">
            <div class="contentLogin">
                <div class="logo-header">
                    <img src="assets/images/logo.svg" alt="" class="img-fluid" srcset="">
                    <h5 class="m-0">{{'DONT_HAVE_ACCOUNT' | translate }} &nbsp;<a (click)="onSignup()" class="fw-medium">{{'SIGN_UP' | translate }}!</a>
                    </h5>
                </div>
                <div class="loginbox">
                    <h2 class="text-left mb-4 fw-light">{{'FORGOT_YOUR_PASSWORD' | translate }}?</h2>
                    <form class="login-form" [formGroup]="forgetPasswordForm" (ngSubmit)="form.form.valid"
                        #form="ngForm">
                        <div class="mb-3">
                            <mat-label>{{'ENTER_REGISTERED_EMAIL' | translate }}</mat-label>
                            <input matInput class="w-100 form-control" [placeholder]="'ENTER_REGISTERED_EMAIL' | translate"
                                formControlName="email">
                            <mat-error class="text-danger"
                                *ngIf="(form.submitted || forgetPasswordForm.get('email')?.touched) && forgetPasswordForm.controls['email'].errors?.['required']">
                                {{'EMAIL_REQUIRED' | translate }}
                            </mat-error>
                            <mat-error class="text-danger"
                                *ngIf="(form.submitted || forgetPasswordForm.get('email')?.touched) && forgetPasswordForm.controls['email'].errors?.['pattern']">
                                {{'EMAIL_INVALID_MSG' | translate }}
                            </mat-error>
                        </div>
                        <div class="mb-3">
                            <p>{{'FORGOT_PASSWORD_DESC' | translate}}
                            </p>
                        </div>
                        <button mat-flat-button color="primary" class="my-3 w-100" (click)="onSubmit()">{{'SUBMIT' | translate }}</button>

                    </form>
                </div>
            </div>

        </div>
        <div class="col-lg-5 p-0">
            <div class="image-height forgot-bg">
                <p>&nbsp;</p>
            </div>

        </div>
    </div>
</div>